//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getTaggedProductsStats } from '@apis/universal-image-actions/universalImageActionsApi';
import ClientId from '@models/ClientId';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';
import { getClientId } from '@redux/selectors/getClientId';
import { isDefined } from '@utils/filterPredicates';

export const useGetTaggedProductsStatsQuery = (
  publisherClientId?: ClientId,
) => {
  const clientId = useSelector(getClientId);

  return useQuery({
    enabled: isDefined(publisherClientId),
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsProducts,
      QueryKeyConstants.UniversalImageActionsProductsTaggedProducts,
      clientId,
      publisherClientId,
    ],
    queryFn: async ({ signal }) => {
      if (isDefined(publisherClientId)) {
        return getTaggedProductsStats(
          { clientId, publisherClientId },
          { signal },
        );
      }
    },
    staleTime: FIVE_MINUTES_STALE_TIME,
  });
};
